import React from "react";

function Sidebar({ setPage, currentPage }) {

  /* GET USER ROLE */

  const role = localStorage.getItem("role");

  const menuItem = (title, pageName, icon) => {

    const active = currentPage === pageName;

    return (

      <div
        onClick={() => setPage({ page: pageName })}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "12px 15px",
          marginBottom: "6px",
          borderRadius: "6px",
          cursor: "pointer",
          background: active ? "#1f2a38" : "transparent",
          color: active ? "#fff" : "#ccc",
          transition: "0.2s"
        }}
      >

        <span style={{ fontSize: "18px" }}>{icon}</span>

        <span>{title}</span>

      </div>

    );

  };

  return (

    <div
      style={{
        width: "230px",
        background: "#0f1720",
        color: "#fff",
        minHeight: "100vh",
        padding: "25px 18px",
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0
      }}
    >

      {/* LOGO */}

      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          marginBottom: "35px",
          letterSpacing: "1px"
        }}
      >
        MaAz
      </div>

      {/* MENU */}

      {menuItem("Dashboard", "dashboard", "📊")}

      {/* ONLY MASTER ADMIN */}

      {role === "master_admin" && menuItem("Industries", "industries", "🏭")}

      {menuItem("Courses", "courses", "📚")}
      {menuItem("Modules", "modules", "📂")}
      {menuItem("Lessons", "lessons", "🎬")}
      {menuItem("Students", "students", "👨‍🎓")}

      {/* ONLY MASTER ADMIN */}

      {role === "master_admin" && menuItem("Admins", "admins", "👨‍💼")}

      {(role === "master_admin" || role === "admin") && menuItem("Trainers", "trainers", "🧑‍🏫")}

    </div>

  );

}

export default Sidebar;